import React from 'react'
import LogoSvg from '../../../assets/svg/logo.svg'
import * as styles from './index.module.css'

const Logo = () => (
  <LogoSvg className={styles.logo} />
)

export default Logo
